module.exports = __webpack_public_path__ + "02_long_brown.7f0dc05a.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/papa/layer5/02_long_brown.png
// module id = fp13
// module chunks = 0